<template>
  <v-row class="mb-2">
    <v-col cols="auto">
      <botao-avancar />
      <botao-anterior />
    </v-col>
  </v-row>
</template>

<script>
import BotaoAnterior from "../components/BotaoAnterior.vue";
import BotaoAvancar from "./BotaoAvancar.vue";

export default {
  components: {
    BotaoAnterior,
    BotaoAvancar,
  },
};
</script>

<style>
</style>